<script lang="ts">
  import Button from '$components/reusable/Button.svelte';
  import Divider from '$components/reusable/Divider.svelte';
  import GithubLogo from '$icons/logos/GithubLogo.svelte';
  import GoogleLogo from '$icons/logos/GoogleLogo.svelte';
  import TwitterLogo from '$icons/logos/TwitterLogo.svelte';
  import { oauthLogin } from '$utils/auth/supertokens';
</script>

<div class="space-y-3xl mt-auto flex flex-col">
  <Divider />
  <div class="space-y-md w-full">
    <Button tertiary class="!h-10 w-full" on:click={() => oauthLogin('google')}>
      <GoogleLogo slot="left-icon" class="mr-0.5 h-6 w-6" />
      <span>Continue with Google</span>
    </Button>
    <Button tertiary class="!h-10 w-full" on:click={() => oauthLogin('github')}>
      <GithubLogo slot="left-icon" class="h-6 w-6" />
      <span>Continue with GitHub</span>
    </Button>
    <Button tertiary class="hidden !h-10 w-full" on:click={() => oauthLogin('x')}>
      <TwitterLogo slot="left-icon" class="mr-1 h-4 w-4" />
      <span>Continue with X</span>
    </Button>
  </div>
</div>
